/** POS-1927: approval actions the backend can verify server-side. */
export type OperatorApprovalAction = 'void' | 'refund' | 'discount' | 'cancel';

export const OPERATOR_APPROVAL_ACTIONS: readonly OperatorApprovalAction[] = [
  'void',
  'refund',
  'discount',
  'cancel'
];

export interface OperatorSignIn {
  operator_id: number;
  operator_session_token: string;
  operator_session_expires_at: string;
  manager_access_jwt: string | null;
}

export interface OperatorApproval {
  approving_operator_id: number;
  approval_action: OperatorApprovalAction;
  approval_token: string;
  expires_at: string;
}

/** The `status` the backend sends with a failed sign-in or approval. */
export type OperatorAuthFailure =
  | 'invalid_pin'
  | 'too_many_attempts'
  | 'pin_reset_required'
  | 'insufficient_permissions'
  | 'operator_authentication_required'
  | 'unknown';
